<template>
    <div class="video-play">
        <div v-if="error" class="error-page flex-in-middle">
            <div class="text-center">
                <div class="title mb-3">直播源未准备好，请稍等再重试!</div>
                <el-button type="info" icon="el-icon-retry" @click="retry">{{ countdown }} 秒后重试</el-button>
            </div>
        </div>
        <video :ref="player_name" class="video-js vjs-big-play-centered"
               playsinline
               autofocus
               style="width:100%; height:100%; object-fit: contain"></video>
    </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import videojs from 'video.js';

window.HELP_IMPROVE_VIDEOJS = false;

export default {
    name: "VideoPlayer",
    props: {
        source: {
            type: String,
        },
        poster: {
            type: String,
        },
        autoplay: {
            type: Boolean
        },
        muted: {
            type: Boolean
        },
        controls: {
            type: Boolean,
        },
    },
    data() {
        return {
            player: null,
            options: {
                autoplay: false,
                controls: this.controls,
                poster: this.poster,
                sources: [],
                muted: this.muted,
            },
            error: false,
            countdown: 30,
            countdown_timer: 0,
            timer: 0,
            player_name: "video_player" + (new Date().getTime())
        }
    },
    watch: {
        source(newVal) {
            const vm = this;
            this.$nextTick(
                () => {
                    if (newVal) {
                        vm.setSource(newVal);
                    }
                }
            );
        }
    },
    mounted() {
        const vm = this;
        const options = Object.assign({}, this.options);

        this.player = videojs(this.$refs[this.player_name], options, function onPlayerReady() {
                window.player = vm.player;
                if (vm.source) {
                    vm.setSource(vm.source);
                }
                this.on('ended', function () {
                });
                this.on('error', function () {
                    console.error('media interrupt');
                    vm.player.pause();
                });
                this.on('playing', function () {
                    vm.error = false;
                    if (vm.countdown_timer) {
                        vm.removeCountdownTimer();
                    }
                })
            }
        )

    },
    methods: {
        setSource(src) {
            const vm = this;
            vm.player.src({
                src: src,
                type: src.indexOf('.mp4') > -1 ? 'video/mp4' : 'application/x-mpegURL'
            });
            vm.player.load();
            if (vm.autoplay) {
                vm.player.play();
            } else
                vm.player.pause();
        },
        retry() {
            this.player.src(this.source);
            this.player.load();
            this.player.play();
            clearInterval(this.countdown_timer);
            this.countdown_timer = 0;
        }
        ,
        removeCountdownTimer() {
            if (this.countdown_timer) {
                clearInterval(this.countdown_timer);
                this.countdown_timer = 0;
            }
        },
        removeTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = 0;
            }
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
        this.removeCountdownTimer();
        this.removeTimer();
    }
}
</script>

<style lang="scss">
.video-play {
    position: relative;
    height: 100%;
    width: 100%;

    .error-page {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 20;

        .title {
            font-size: 1.5rem;
            color: white;
        }
    }

}
</style>
